import { Box, ButtonGroup } from "@mui/material";
import { useTheme } from "@mui/material";

import { tokens } from "../../../../../theme";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetAllRelationInvoiceProductsQuery, useToggleRelationInvoiceProductsActiveMutation, useUpdateRelationInvoiceProductsMutation } from "../../../../../newapi/global/relation/relationSlice";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import Text from "../../../../../components/theme/text/Text";
import ShSwitch from "../../../../../components/theme/inputs/ShSwitch";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { formatPrice } from "../../../../../utils/helpers";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import EditIcon from '@mui/icons-material/Edit';
import MUpdateRelationInvoiceProduct from "../../../../../components/global/Modals/MUpdateRelationInvoiceProduct";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import MConfirmation from "../../../../../components/global/Modals/MConfirmation";
import { useUpdateProductPriceConceptInvoicesMutation } from "../../../../../newapi/financial/invoiceSlice";
import MLoader from "../../../../../components/global/Modals/MLoader";
import { showToastMessage, showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../utils/toasts";
import ShDataGridSelectedActions from "../../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import DropdownButton from "../../../../../components/theme/buttons/DropdownButton";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';

const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    

};

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    return <ButtonGroup version={2}>
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                onClick={props.handleOpen}
                endIcon={<EditIcon/>}
                variant="contained"
            >
                {t('update_price_concept_invoice')}
            </Shbutton>
        </ButtonGroup>
}

const Financial = (props) => {
    const {t, i18n} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 
    const [data, setData] = useState([]);
    const [config, setConfig] = useState({id: props.relationId, onlyActive: false});

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RELATION_MANAGE])
    );
    
    const [updateModalOpen, setUpdateModalOpen] = useState(false);
    const updateModal = {
        open: updateModalOpen,
        setOpen: setUpdateModalOpen
    }
    
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const confirmModal = {
        open: confirmModalOpen,
        setOpen: setConfirmModalOpen
    }

    const handleOpen = () => {
        confirmModal.setOpen(true);
    }
  
    const handleCloseUpdate = () => {
        setSelectedProduct(null);
        setUpdateModalOpen(false);
    };

    const [updateLoaderModalOpen, setUpdateLoaderModalOpen] = useState(false);
    const [updateResponseMessage, setUpdateResponseMessage] = useState(null);
    const updateLoaderModal = {
        open: updateLoaderModalOpen,
        setOpen: setUpdateLoaderModalOpen,
    };
        
    const [updatePrices,{isLoading}] = useUpdateProductPriceConceptInvoicesMutation();
    const handleUpdateProductPrices = async () => {
        try {
            if(isLoading) return;
            updateLoaderModal.setOpen(true);
            setUpdateResponseMessage(null);

            const response = await updatePrices({relationId: props.relationId}).unwrap();
            
            if (response.success && response.rowsModified === 0) {
                updateLoaderModal.setOpen(false);
                showToastMessage("success", t("prices_modified"));
            } else {
                const message = `${response.rowsModified} ${t("_invoice_mutations_modified")}`;
                setUpdateResponseMessage(message);
            }
        } catch (err) {
            showToastMessageRequestError(t("update_failed"), t, err);
            updateLoaderModal.setOpen(false);
        }
    };

    const [selectedItems, setSelectedItems] = useState([]);
    const [toggleActive, {isLoading: toggleLoading}] = useToggleRelationInvoiceProductsActiveMutation();

    // Every selected rate flips against its own current value, so a mixed selection comes back
    // with each row on the opposite of where it started.
    const handleToggleActive = async () => {
        if (selectedItems.length === 0) return;
        if (toggleLoading) return;

        try {
            const response = await toggleActive({relationId: props.relationId, ids: selectedItems}).unwrap();
            setSelectedItems([]);
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            showToastMessageRequestError(t("update_failed"), t, err);
        }
    };

    const [productUpdates, setProductUpdates] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        if (selectedProduct) {
            updateModal.setOpen(true);
        }
    }, [selectedProduct]);

    useEffect(() => {
        props.replaceView({
            ...props.config,
            mobileActions: <GridActions handleOpen={handleOpen}> </GridActions>,
            gridOptions:gridOptions,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    const handleChange = (product, key, newValue) => {
        const newProductUpdates = [...productUpdates];
        const productUpdate = newProductUpdates.find(p => p.id === product.id)
        if (productUpdate) {
            productUpdate[key] = newValue;
        } else {
            const newProductUpdate = {id: product.id, isActive: product.isActive, isCustomPrice: product.isCustomPrice, price: product.price};
            newProductUpdate[key] = newValue;
            newProductUpdates.push(newProductUpdate);
        }
        setProductUpdates(newProductUpdates);
    }
    
    const columns = [
        {
            field: "name", 
            headerName: t('name'),
            flex:2, 
            cellClassName: "sku-cell", 
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.invoiceProduct.name
            }
        },
        {
            field: "isActive", 
            headerName: t('active'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.isActive) {
                    return <CheckIcon sx={{color: colors.green[400]}}/>
                } else {
                    return <ClearIcon sx={{color: colors.red[400]}}/>
                }
                
            }
        },
        {
            field: "invoiceCategory", 
            headerName: t('category'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.categoryProduct?.invoiceCategory?.name
            }
        },
        {
            field: "isCustomPrice", 
            headerName: t('custom_price'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.isCustomPrice) {
                    return <CheckIcon sx={{color: colors.green[400]}}/>
                } else {
                    return <ClearIcon sx={{color: colors.red[400]}}/>
                }
            }
        },
        {
            field: "price", 
            headerName: t('price'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.isCustomPrice) {
                    return formatPrice(i18n, params.row.price)
                } else {
                    return formatPrice(i18n, params.row.categoryProduct?.price)
                }
            }
        },
        {
            field: "actions", 
            headerName: "",
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return <Box>
                    {hasModifyPrivilege && (
                        <>
                    <IconButton type="button" onClick={() => setSelectedProduct(params.row)}
                    sx={{ 
                        color: colors.txt["primary"]
                    }}>
                        <EditIcon/>
                    </IconButton>
                </>
                    )}
            </Box>
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return <></>
            }
        },
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}
            sx={{
                "& .sku-cell" : {
                    paddingLeft:0,
                },
                "& [aria-label='SKU']" : {
                    paddingLeft:0,
                },
            }}
        >
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetAllRelationInvoiceProductsQuery}
                config={config}
                itemId={props.relationId}
                gridActions={<GridActions handleOpen={handleOpen}> </GridActions>} 
                title={t('invoice_products')}
                gridOptions={gridOptions} 
                isSidepanelGrid={props.isSidepanelGrid ?? false}
                columns={columns} 
                rows={data}
                {...(hasModifyPrivilege && {
                    selectable: true,
                    setSelected: setSelectedItems,
                    selectedItems: selectedItems,
                    selectedActions: (
                        <ShDataGridSelectedActions selectedItems={selectedItems} closeOnChildClick>
                            <DropdownButton
                                onClick={handleToggleActive}
                                icon={<ToggleOnIcon/>}
                                text={t("change_active_status")}
                                disabled={toggleLoading}
                            />
                        </ShDataGridSelectedActions>
                    )
                })}>
            </ShDataGrid2>
            <MUpdateRelationInvoiceProduct relationId={props.relationId} productInfo={selectedProduct} onOpen={() => updateModal.setOpen(true)} onClose={() => updateModal.setOpen(false)} open={updateModal.open} handleClose={handleCloseUpdate}/>
            <MConfirmation
                open={confirmModal.open}
                handleClose={() => confirmModal.setOpen(false)}
                title={t("update_invoice_product_price_title")}
                content={t("update_invoice_product_price_content")}
                confirm={() => handleUpdateProductPrices()}
            />
            <MLoader
                open={updateLoaderModal.open}
                handleClose={() => updateLoaderModal.setOpen(false)}
                message={t("updating_prices")}
                responseMessage={updateResponseMessage}
            />
        </Box>
    );
}

export default Financial;